module.exports = __webpack_public_path__ + "img/CellCycle-BRCA_GSE176078.8edd8664.png";